const form = document.querySelector("#product-form");

// Post cart data ################################################################
// ###############################################################################

function add_cart(e) {
  // Prevent defaults action (used to avoid refresh on form submit)
  e.preventDefault();

  // e.target is the element of the event and allow us to access element data such as dataset.
  const formElem = e.target; // Find the element by its data-scr
  const id = formElem.querySelector('[name="id"]:checked');

  let formData = {
    items: [
      {
        id: id.value,
        quantity: 1,
      },
    ],
    attributes: {
      // Add here custom attributes
    },
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      const status = response.status;
      updateDrawer();
      setTimeout(() => {
        document.getElementById('drawer').classList.toggle('active');
      })
    }).catch((error) => {
      console.error(error);
    });
}

if (form) {
  form.addEventListener('submit', (e) => {
    add_cart(e);
  });
}
function removeItem( id) {

  let formData = { id: id, quantity: 0 };

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      const resp = response.json();
      const status = response.status;

      if (status === 200) {
        console.log('removed')
        updateDrawer();
      }
      console.log(status);
    })
    .catch((error) => {
      console.error(error);
    });

}

// Remove cart item ##############################################################
// ###############################################################################

function remove_cart_item(e) {
  e.preventDefault();
  // Get id from dataset
  const id = e.target.dataset.id;
  console.log(id);
  let formData = { id: id, quantity: 0 };

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      const resp = response.json();
      const status = response.status;

      if (status === 200) {
        // Refresh page to update fronted.
        location.reload();
      }
      get_cart();
      console.log(status);
    })
    .catch((error) => {
      console.error(error);
    });
}
